<template>
    <div class="h-100 hyper-login" :style="`background-image:url(${backgrounImage});`">
        <div class="logo">
            <img
                :src="logoImage"
                :onError='`this.onerror=null;this.src="${logoBaseUrl}/hyperbilling-light-logo.png"`'
                :alt="VUE_APP_NAME"
            >
        </div>
        <LoginForm/>
        <Footer v-if="!isMobile" />
    </div>
</template>
<script>
import md5 from 'md5'
import isMobileLib from 'is-mobile'
import { computed, ref } from '@vue/composition-api'
import useAppConfig from '@core/app-config/useAppConfig'
import useEnvString from '@/composables/useEnvString'

import LoginForm from './LoginForm'
import Footer from '@/views/Shared/Footer'
export default {
    components: {
        LoginForm,
        Footer
    },
    setup () {
        const { skin } = useAppConfig()
        const {
            VUE_APP_HYPER_V3_CONTENT,
            VUE_APP_NAME,
            VUE_APP_NAMESPACE,
            VUE_APP_SERVICE,
            VUE_APP_AUTH_CENTER_URL
        } = useEnvString()

        const logoBaseUrl = VUE_APP_HYPER_V3_CONTENT + '/logo'
        const logoImage = `${logoBaseUrl}/logo/${md5(VUE_APP_NAMESPACE + '-' + VUE_APP_SERVICE)}.png`
        const backgrounImage = `${logoBaseUrl}/bg/${md5(VUE_APP_NAMESPACE + '-' + VUE_APP_SERVICE)}.png`
        const isMobile = computed(() => isMobileLib())
        const locale = ref(localStorage.getItem('locale'))
        return {
            VUE_APP_NAME,
            VUE_APP_NAMESPACE,
            VUE_APP_AUTH_CENTER_URL,
            logoBaseUrl,
            logoImage,
            backgrounImage,
            locale,
            isMobile,
            skin
        }
    }
}
</script>
<style>
/** BACKGROUN */
.hyper-login:before {
    content: '';
    background-color: rgba(255, 255, 255, 0.1);
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
}
.hyper-login {
    background-size: cover;
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-position: center;
    min-height: 600px;
    height: 100vh;
}
/** LOGO */
.logo {
    display: block;
    max-width: 300px;
    margin: 0 auto;
    position: absolute;
    top: 0;
    background-color: inherit;
    padding: 1.5rem;
}
.logo img {
    width: 100%;
    display: block;
}

</style>
